module.exports = __webpack_public_path__ + "img/81144bd.png";